// TODO: fix misspelling of Occured
// Sync with BE: property naming is from the backend model
import React from 'react';

import { GetAppOutlined } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

import { IOrderTransactionEvent } from '../../../../types/Events';
import { exportCsv } from '../../../utils/exporter';
import { formatDate } from '../../../utils/helpers';

interface dialogProps {
  open: boolean;
  onClose?: () => void;
  data: IOrderTransactionEvent[];
}

export default function ViewHistory(props: dialogProps) {
  const { data, open, onClose } = props;

  const handleClickClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleClickExport = () => {
    const col = ['Name', 'TimeOccured', 'Signer'];
    exportCsv(data, col);
  };

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={open}
      scroll={'paper'}
      aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>
        <div className='view-history-title-bar'>
          View History
          <Button
            className='title-btn'
            startIcon={<GetAppOutlined />}
            onClick={handleClickExport}
            color='primary'>
            Export
          </Button>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <List dense>
          {data.map((item, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={
                  (item.Signer
                    ? item.Name + ' (' + item.Signer + ')'
                    : item.Name) as string
                }
                secondary={formatDate(
                  item.TimeOccured,
                  'ddd, MMM Do YYYY, h:mm:ss A'
                )}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
